export enum AuthType {
  saml = "saml",
  password = "password",
  oAuth = "oAuth"
}
